import { CommonModule }        from '@angular/common';
import { NgModule }            from '@angular/core';
import { FormsModule }         from '@angular/forms';
import { SvgModule }           from '@shared/components/svg/svg.module';
import { TextFilterComponent } from '@shared/list-operations/components/text-filter/text-filter.component';


@NgModule( {
	declarations: [
		TextFilterComponent
	],
	imports: [
		// Angular
		CommonModule,
		FormsModule,

		// Shared
		SvgModule
	],
	exports: [
		TextFilterComponent
	]
} )
export class TextFilterModule {}
